// eslint-disable-next-line @typescript-eslint/no-unused-vars

import { settings } from '@alme/ui-web/settings/settings-util';

import AlmeWindow from '@alme/ui-web/ref/window';
import CustomAlmeWindowLaunchPoint from '../modules/custom-window-launchpoint/customwindowlaunchpoint';
import WindowHeader from '@alme/ui-web/ref/window-header';
import HeaderBanner from '@alme/ui-web/ref/window-header-banner';
import HeaderToolbar from '@alme/ui-web/ref/window-header-toolbar';
import ConversationArea from '@alme/ui-web/ref/window-conversationarea';
import WindowFooter from '@alme/ui-web/ref/window-footer';
import InputBox from '@alme/ui-web/ref/window-inputbox';
import SkipToContent from '@alme/ui-web/ref/window-skip-to-content';
import TimeoutWarningOverlay from '@alme/ui-web/ref/timeout-warning-overlay';
import ScrollBehavior from '@alme/ui-web/ref/conversationarea-scrolltoinput';
import WindowTabletMutator from '@alme/ui-web/ref/window-tablet-mutator';
import MinimizeWindow from '@alme/ui-web/ref/window-minimize';
import DragWindow from '@alme/ui-web/ref/window-jquery-drag';
import AlmeMessageRenderer from '@alme/ui-web/ref/message-renderer-alme';
import UserMessageRenderer from '@alme/ui-web/ref/message-renderer-user';
import MessageRendererNotification from '@alme/ui-web/ref/message-renderer-notification';
import { MessageRendererInlineSurveyLinks } from '@alme/ui-web/ref/message-renderer-inline-survey-links';
import FeedbackOverlay from '@alme/ui-web/ref/simple-feedback-overlay';
import { InlineLinksRenderer } from "@alme/ui-web/ref/message-renderer-display-links";
import ErrorMessageRenderer from "@alme/ui-web/ref/message-renderer-errors";

import ChatSurveyOverlay from '@alme/ui-web/ref/window-feedback-overlay';
import ModuleLangAttrib from '@alme/ui-web/ref/lang-attrib';


//custom modules
import CustomCallToActionButtonMessageRenderer from '../modules/custom-message-renderer-call-to-action/message-renderer-call-to-action';
import LaunchPointWindowModule from '../modules/window-launch/window-launch';
import DisplayLinksRenderer from '../modules/custom-message-renderer-display-links/custom-message-renderer-display-links';
import NavUrlRenderer from '../modules/custom-message-renderer-nav-url/custom-message-renderer-nav-url';

// Custom Modules - Alight Specific
import AdvocacyChatBubble from '../modules/advocacy-chat-bubble/advocacy-chat-bubble';
import CustomIva from '../modules/custom-iva/custom-iva';
import CustomAvatar from '../modules/custom-avatar/custom-avatar';
import LaunchPointMutator from '../modules/mutators/launchPointMutator';
import InputBoxCounterMutator from '../modules/mutators/inputCounterMutator';
import IVAFullScreenMutator from '../modules/mutators/ivaFullScreenMutator';
import MobileMutator from '../modules/mutators/mobileMutator';
import EmbeddedIva from '../modules/embedded-iva/embeddedIva';


function setupAlmeHeader(components) {
    const toolbarChildComponents = [
        components.minimizeWindow,
        components.dragWindow,
    ];

    components.mobileMutator = new MobileMutator(settings);
    
    components.headerToolbar = new HeaderToolbar(null, [], Object.values(toolbarChildComponents));
    components.headerBanner = new HeaderBanner(null, [], []);

    const headerMutatorModules = [
        components.dragWindow,
        components.mobileMutator,
    ];

    const headerChildComponents = [
        components.headerBanner,
        components.headerToolbar,
        components.liveChatFoundation.UI.header,
    ];

    return new WindowHeader(null, Object.values(headerMutatorModules), Object.values(headerChildComponents));
}

function setupConversationArea(components) {
    components.customAvatar = new CustomAvatar(settings);
    
    components.navUrlRenderer = new NavUrlRenderer(null, components.stepOutIcon);
    components.inlineLinkRenderer = new InlineLinksRenderer(null, components.stepOutIcon);
    components.displayLinkRenderer = new DisplayLinksRenderer(null, components.stepOutIcon);
    components.errorRenderer = new ErrorMessageRenderer();
    components.inlineSurveyLinksRenderer = new MessageRendererInlineSurveyLinks(settings, components.singleLinkRenderer);
    components.callToActionButtonRenderer = new CustomCallToActionButtonMessageRenderer(settings, components.singleLinkRenderer,components.stepOutIcon, components.launchOffersEventUtility);

    const preRenderComponents = [
        components.customAvatar,
    ];

    const almeMessageComponents = [
        components.navUrlRenderer,
        components.errorRenderer,
        components.inlineLinkRenderer,
        components.displayLinkRenderer,
        components.callToActionButtonRenderer,
        components.inlineSurveyLinksRenderer,
    ];


    components.almeMessageRenderer = new AlmeMessageRenderer(null, [], preRenderComponents, almeMessageComponents);
    components.userMessageRenderer = new UserMessageRenderer();
    components.advocacyChatBubble = new AdvocacyChatBubble(settings, [], preRenderComponents, almeMessageComponents, []);
    components.notificationMessageRenderer = new MessageRendererNotification(settings, [], []);

    const conversationAreaMessageComponents = [
        components.almeMessageRenderer,
        components.userMessageRenderer,
        components.notificationMessageRenderer,
        components.advocacyChatBubble,
        components.liveChatFoundation.UI.input,
        components.liveChatFoundation.UI.response,
        components.liveChatFoundation.UI.connectBanner,
        components.liveChatFoundation.UI.disconnectBanner,
        components.liveChatFoundation.UI.queuedBanner,

    ];

    return new ConversationArea(null, Object.values(conversationAreaMessageComponents), [], []);
}

function setupAlmeFooter(components) {
    components.inputBoxCounterMutator = new InputBoxCounterMutator(settings);
    components.ivaFullScreenMutator = new IVAFullScreenMutator(settings);
    components.moduleLangAttrib = new ModuleLangAttrib(settings);

     // Rendering components - require mutators and child components
     const inputBoxMutators = [
        components.inputboxLockMutator,
        components.moduleLangAttrib,
        components.liveChatFoundation.UI.inputBox,
        components.liveChatFoundation.UI.inputBoxButton,

        components.inputBoxCounterMutator,
        components.ivaFullScreenMutator,
    ];

    components.inputBox = new InputBox(null, [], inputBoxMutators, [components.liveChatFoundation.UI.inputBoxButton], []);

    const footerChildComponents = [
        components.liveChatFoundation.UI.endChatLink,
        components.inputBox,
        components.liveChatFoundation.UI.typingNotification,
    ];

    return new WindowFooter(null, [], footerChildComponents);
}

function setupAlmeWindow(components) {
    //window components
    components.launchPointMutator = new LaunchPointMutator(settings);
    components.skipToContent = new SkipToContent();
    components.launchPoint = new LaunchPointWindowModule(settings, [components.launchPointMutator, components.launchOffersProcessor]);
    components.timeoutWarningOverlay = new TimeoutWarningOverlay();
    components.scrollBehavior = new ScrollBehavior();
    components.windowTabletMutator = new WindowTabletMutator();
    components.minimizeWindow = new MinimizeWindow();
    // Disable - components.resizeWindow = new ResizeWindow();
    components.dragWindow = new DragWindow();
    components.feedbackOverlay = new FeedbackOverlay(undefined, components.singleLinkRenderer);

    components.chatSurveyOverlay = new ChatSurveyOverlay(settings);
    components.customIva = new CustomIva(settings);
    components.embeddedIva = new EmbeddedIva(settings);



    
    const OverlayRenderer = components.chatSurveyOverlay.getOverlayRenderer();
    const paneRenderers = components.chatSurveyOverlay.getPaneRenderers();
    components.overlayRenderer = new OverlayRenderer(settings, paneRenderers);

    components.windowHeader = setupAlmeHeader(components);
    components.conversationArea = setupConversationArea(components);
    components.windowFooter = setupAlmeFooter(components);

    const customAlmeWindowLaunchPointMutators = [
        components.launchPoint,
    ];

    const customAlmeWindowLaunchPointChildComponents = [
        components.launchPoint,
    ];

    const almeWindowMutators = [
        components.minimizeWindow,
        components.liveChatFoundation.UI.window,
        components.customIva,
        components.moduleLangAttrib,
        components.windowTabletMutator,
        components.embeddedIva,
    ];

    const almeWindowChildComponents = [
        components.windowHeader,
        components.skipToContent,
        components.conversationArea,
        components.timeoutWarningOverlay,
        components.windowFooter,
        components.feedbackOverlay,
        components.singleLinkRenderer,
        components.overlayRenderer,
        components.liveChatFoundation.UI.endChatWarningOverlay,
    ];
    

    components.almeWindow = new AlmeWindow(null, Object.values(almeWindowMutators), almeWindowChildComponents);
    components.customAlmeWindowLaunchPoint = new CustomAlmeWindowLaunchPoint(null, Object.values(customAlmeWindowLaunchPointMutators), customAlmeWindowLaunchPointChildComponents);

    return components;
}

export {
    setupAlmeWindow
};



// WEBPACK FOOTER //
// ./src/setup-window-components.js